export function useInitialOnce<T>(key: string): T | null {
    if (!process.client) return null;

    const w = window as any;

    if (!w.__PIPELINE_DATA__?.[key]) return null;

    const data = w.__PIPELINE_DATA__[key] as T;

    delete w.__PIPELINE_DATA__[key];

    return data;
}